module.exports = __webpack_public_path__ + "img/the-underground-railroad.38fb7c98.png";